module.exports = "/_next/static/images/constructionBanner-b04db9aabb06e142049d1e2c9f465c77.webp";